import { FC, ReactNode } from 'react';

export interface LinhaTooltip {
  rotulo: string;
  valor: string;
  cor?: string;
}

/** Caixa de tooltip dos gráficos do painel: título + pares rótulo/valor alinhados. */
const TooltipBox: FC<{ titulo: ReactNode; linhas: LinhaTooltip[]; rodape?: ReactNode }> = ({
  titulo,
  linhas,
  rodape,
}) => (
  <div className="rounded-lg border border-theme-border bg-surface-card px-3 py-2 text-xs shadow-lg min-w-[180px]">
    <div className="mb-1 font-semibold text-content-primary">{titulo}</div>
    <dl className="space-y-0.5">
      {linhas.map((l) => (
        <div key={l.rotulo} className="flex items-center justify-between gap-4">
          <dt className="flex items-center gap-1.5 text-content-secondary">
            {l.cor && <span aria-hidden className="inline-block h-2 w-2 rounded-sm" style={{ backgroundColor: l.cor }} />}
            {l.rotulo}
          </dt>
          <dd className="font-medium text-content-primary tabular-nums">{l.valor}</dd>
        </div>
      ))}
    </dl>
    {rodape && <div className="mt-1.5 border-t border-theme-border pt-1.5 text-content-muted">{rodape}</div>}
  </div>
);

export default TooltipBox;
